import { Button, ButtonRow } from '@ksyos/design-system';
import { useEffect, useState } from 'react';
import type { IQuestionnaireFormProps } from '../../../Questionnaire';
import type { IHsdqQuestion } from '../NewHsdqQuestionnaire';
import { hsdqQuestionOptions } from '../../../../../../../common/validation/customControls/somnology';
import { Step } from '../../../../../elements/atoms/step/Step';
import { CustomContainer } from '../../../../../elements/molecules/customContainer/CustomContainer';
import { Stack } from '../../../../../elements/molecules/stack/Stack';
import { PageIntro } from '../../../../../elements/organisms/pageIntro/PageIntro';
import { QuestionnaireRadioGroup } from '../../../../../elements/organisms/questionnaireRadioGroup/QuestionnaireRadioGroup';
import { StyledFormGroup } from '../../../../../elements/organisms/StyledFormGroup/StyledFormGroup';

export function Step7(props: IQuestionnaireFormProps) {
    const [isSaving, setIsSaving] = useState<boolean>(false);

    useEffect(() => {
        if (props.errors.size === 0) {
            setIsSaving(false);
        }
    }, [props.errors.size]);

    const questions: IHsdqQuestion[] = [
        {
            key: 'sleepWalking',
            label: 'Ik heb last van slaapwandelen',
            number: 31,
        },
        {
            key: 'unintentionallyFallAsleepDuringDay',
            label: 'Ik val overdag ongewild in slaap, vooral in een saaie situatie (bijvoorbeeld bij een saai tv-programma',
            number: 32,
        },
    ];

    return (
        <>
            <PageIntro title="HSDQ: vragen deel 7/7" />

            <CustomContainer>
                {questions.map((question) => {
                    return (
                        <Stack key={question.key}>
                            <Step>{question.number}/32</Step>
                            <StyledFormGroup
                                hasErrors={props.errors.has(question.key)}
                                label={question.label}
                                layout="vertical"
                            >
                                <QuestionnaireRadioGroup
                                    {...props}
                                    customControlData={props.procedure.customControlData}
                                    customControlKey={question.key}
                                    questionnaireOptions={hsdqQuestionOptions}
                                />
                            </StyledFormGroup>
                        </Stack>
                    );
                })}

                <ButtonRow justify="right">
                    <Button
                        color="secondary"
                        isDisabled={isSaving}
                        onClick={async () => {
                            setIsSaving(true);
                            if (props.submit) {
                                await props.submit();
                            }
                        }}
                        variant="solid"
                        width="full-below-small"
                    >
                        Verzenden
                    </Button>
                </ButtonRow>
            </CustomContainer>
        </>
    );
}
